// The reduxV2 create and update sagas resolve with the raw success envelope
// (`{ data: entity, debugInfo }`), while a list yields the entities directly.
// Peel the envelope so a mapper always gets the entity itself: mapped from the
// envelope, a cost had no id and no target, so the settlement wizard could not
// select a cost it had just created.
export const unwrapEntity = <TEntity>(response: unknown): TEntity => {
  const envelope = response as { data?: TEntity } | null | undefined;
  return (envelope?.data ?? response) as TEntity;
};
